// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DdtDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';
import { map } from 'rxjs';

export interface DdtMaintenanceSelectOption {
  id: string;
  requestNumber?: number;
  maintenanceNumber?: number;
  sicCode?: string;
  serialNumber?: string;
}

export interface DdtSelectOptionsResponse {
  correctiveMaintenances: DdtMaintenanceSelectOption[];
  scheduledMaintenances: DdtMaintenanceSelectOption[];
}

@Injectable()
export class DdtApiClient extends BaseCRUDApiClient<DdtDto> {
  baseUrl = this.config.apiEndpoint + '/ddt';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  createDdt(id: string) {
    return this.http
      .post(
        `${this.baseUrl}/create-ddt`,
        { id: id },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  saveDdt(id: string) {
    return this.http.post(`${this.baseUrl}/save-ddt`, {
      id: id,
    });
  }

  getSelectOptions() {
    return this.http.get<DdtSelectOptionsResponse>(
      `${this.baseUrl}/select-options`,
    );
  }
}
